import { c as _c } from "react/compiler-runtime";
import { SelectGroupRole } from "@components/role/select-group-role";
import { MemberRoleReadOnly } from "@components/table/members/members-column/role-column/member-role-read-only";
import { useChangeMemberRole } from "@hooks/use-change-member-role";
import { useGroupMemberActions } from "@hooks/use-group-member-actions";
import { useGroupRoleXgSeat } from "@hooks/use-group-role-xg-seat";
/** Render and adjust member roles in group context */
export function GroupMemberRole(t0) {
  const $ = _c(17);
  const {
    companyId,
    memberIdentityRole,
    selectedGroup,
    isReadOnly: t1,
    location,
    member
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  const groupMemberActions = useGroupMemberActions(selectedGroup);
  const canEditRole = !isReadOnly && groupMemberActions.canChangeRole(memberIdentityRole);
  let t2;
  if ($[0] !== companyId || $[1] !== location || $[2] !== memberIdentityRole.identity || $[3] !== memberIdentityRole.role || $[4] !== selectedGroup) {
    t2 = {
      companyId,
      location,
      subjectType: "group",
      memberIdentity: memberIdentityRole.identity,
      currentRole: memberIdentityRole.role,
      group: selectedGroup
    };
    $[0] = companyId;
    $[1] = location;
    $[2] = memberIdentityRole.identity;
    $[3] = memberIdentityRole.role;
    $[4] = selectedGroup;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    changeMemberRole
  } = useChangeMemberRole(t2);
  const {
    requestRoleChange,
    xgSeatDialog,
    disabledRoles
  } = useGroupRoleXgSeat({
    member: canEditRole ? member : undefined,
    applyRoleChange
  });
  if (!canEditRole) {
    let t3;
    if ($[6] !== memberIdentityRole.role) {
      t3 = <MemberRoleReadOnly role={memberIdentityRole.role} variant="borderless" />;
      $[6] = memberIdentityRole.role;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  async function applyRoleChange(role) {
    try {
      await changeMemberRole(role);
    } catch {}
  }
  const t3 = memberIdentityRole.role;
  let t4;
  if ($[8] !== requestRoleChange) {
    t4 = role_0 => void requestRoleChange(role_0);
    $[8] = requestRoleChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== disabledRoles || $[11] !== t3 || $[12] !== t4) {
    t5 = <SelectGroupRole selectedRole={t3} onChange={t4} variant="borderless" disabledRoles={disabledRoles} />;
    $[10] = disabledRoles;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5 || $[15] !== xgSeatDialog) {
    t6 = <>{t5}{xgSeatDialog}</>;
    $[14] = t5;
    $[15] = xgSeatDialog;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}